import routes_api from '../connections/routes_api';

export function isPlannerProjectActionUrl(url) {
  if (!url) return false;
  return /\/projects\/[^/?]+\/board\/?(?:\?|$)/.test(url)
    || /\/reorder_columns\/?(?:\?|$)/.test(url)
    || /\/reorder_cards\/?(?:\?|$)/.test(url);
}

const endpointToStoreMap = {
  [routes_api.finance_flows]: 'flows',
  [routes_api.finance_accounts]: 'flow_accounts',
  [routes_api.finance_flows_categories]: 'flow_categories',
  [routes_api.finance_accounts_history]: 'flow_accounts_history',
  [routes_api.finance_budgets]: 'budgets',
  [routes_api.health_records]: 'health_records',
  [routes_api.travel_trips]: 'trips',
  [routes_api.travel_places]: 'places',
  [routes_api.planner_todo]: 'todo',
  [routes_api.planner_todo_items]: 'todo_item',
  [routes_api.planner_calendars]: 'planner_calendars',
  [routes_api.planner_events]: 'planner_events',
  [routes_api.planner_projects]: 'planner_projects',
  [routes_api.planner_project_columns]: 'planner_project_columns',
  [routes_api.planner_project_cards]: 'planner_project_cards',
  [routes_api.notepad_clusters]: 'notepad_clusters',
  [routes_api.notepad_notes]: 'notes',
};

export function getStoreName(url) {
  if (!url || isPlannerProjectActionUrl(url)) return null;
  for (const [endpoint, storeName] of Object.entries(endpointToStoreMap)) {
    if (url.includes(endpoint)) {
      return storeName;
    }
  }
  return null;
}

export function isOfflineSupported(url) {
  return getStoreName(url) !== null;
}

export default endpointToStoreMap;
